"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3952],{

/***/ 33952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(43692);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2746);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44453);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8014);
/* harmony import */ var _BasePopup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73495);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62044);
/* harmony import */ var enums_namespaces__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99731);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56168);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12774);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var enums__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39933);
/* harmony import */ var api_client__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66564);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17651);
/* harmony import */ var enums_cookieAnalytics__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96334);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52662);














var CookiesBar = function(param) {
    var onClose = param.onClose, onAccept = param.onAccept;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(enums_namespaces__WEBPACK_IMPORTED_MODULE_4__/* .Namespace.Common */ .l.Common).t;
    var setPopupConfig = (0,context__WEBPACK_IMPORTED_MODULE_11__/* .usePopup */ .BF)().setPopupConfig;
    var sendAnalytics = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, signature, salt;
        return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,helpers__WEBPACK_IMPORTED_MODULE_9__/* .signCookie */ .Tf)(enums_cookieAnalytics__WEBPACK_IMPORTED_MODULE_10__/* .CookieAnalytics.ALL */ .H.ALL), 2), signature = ref[0], salt = ref[1];
                    _ctx.next = 3;
                    return (0,api_client__WEBPACK_IMPORTED_MODULE_8__/* .getSharedApiClient */ .L)().cookieAnalytics({
                        option: enums_cookieAnalytics__WEBPACK_IMPORTED_MODULE_10__/* .CookieAnalytics.ALL */ .H.ALL,
                        signature: signature,
                        salt: salt
                    });
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    var onLearnMore = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function(e) {
        e.preventDefault();
        setPopupConfig({
            popupType: enums__WEBPACK_IMPORTED_MODULE_7__/* .PopupType.Cookies */ .kQ.Cookies,
            onClose: function() {
                setPopupConfig(null);
            }
        });
    }, []);
    var _onAccept = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function(e) {
        e.preventDefault();
        setPopupConfig(null);
        (0,nookies__WEBPACK_IMPORTED_MODULE_6__.setCookie)(null, enums__WEBPACK_IMPORTED_MODULE_7__/* .CookiesType.AllowAnalytics */ .B4.AllowAnalytics, "true", {
            maxAge: 3600 * 24 * 365 * 2,
            path: "/"
        });
        sendAnalytics();
        onAccept();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_BasePopup__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        showCloseIcon: false,
        classes: [
            "cookies-bar"
        ],
        closeOnEscape: false,
        onClose: onClose,
        showOverlay: false,
        allowBackgroundScrolling: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                children: t("cookies_bar.less_text")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "buttons",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                        onClick: onLearnMore,
                        className: "btn btn-cancel",
                        href: "#",
                        children: t("cookies_bar.learn_more")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                        onClick: _onAccept,
                        className: "btn btn-primary",
                        href: "#",
                        children: t("cookies_bar.accept_all")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CookiesBar);


/***/ }),

/***/ 96334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ CookieAnalytics; }
/* harmony export */ });
var CookieAnalytics;
(function(CookieAnalytics) {
    CookieAnalytics["ALL"] = "ALL";
    CookieAnalytics["ALL_DIALOG"] = "ALL_DIALOG";
    CookieAnalytics["ESSENTIAL_DIALOG"] = "ESSENTIAL_DIALOG";
})(CookieAnalytics || (CookieAnalytics = {}));


/***/ })

}]);